// Tracking seo.js
// SEO metadata utility for updating page meta tags
export function updatePageMeta({ title, description, image, url }) {
  // Update title
  if (title) {
    document.title = title;
    // Update OG title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', title);
    // Update Twitter title
    let twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) twitterTitle.setAttribute('content', title);
  }

  // Update description
  if (description) {
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', description);
    // Update OG description
    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', description);
    // Update Twitter description
    let twitterDesc = document.querySelector('meta[name="twitter:description"]');
    if (twitterDesc) twitterDesc.setAttribute('content', description);
  }

  // Update image (if provided)
  if (image) {
    let ogImage = document.querySelector('meta[property="og:image"]');
    if (ogImage) ogImage.setAttribute('content', image);
    let twitterImage = document.querySelector('meta[name="twitter:image"]');
    if (twitterImage) twitterImage.setAttribute('content', image);
  }

  // Update URL (if provided)
  if (url) {
    let ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', url);
  }
}

// Page-specific metadata configurations
export const pageMeta = {
  home: {
    title: 'The Bikhra Collective',
    description: 'Stories for Diaspora — Curated narratives exploring identity, heritage, and the South Asian experience across borders.',
    url: 'https://bikhra.com/'
  },
  books: {
    title: 'Books — The Bikhra Collective',
    description: 'Explore our collection of visual histories and narratives that illuminate the South Asian diaspora experience.',
    url: 'https://bikhra.com/books',
    image: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/rrqhclq1pks7yvy4sps2m3h3/messages/gemini_generated_image_z7ry5oz7ry5oz7ry-v61f4l05t98.jpg'
  },
  empireFreedom: {
    title: 'Empire & Freedom — The Bikhra Collective',
    description: 'A visual history of India\'s 350-year journey from colonial subjugation to independence. Through archival imagery and narrative, explore the complex story of Empire and the birth of modern India.',
    url: 'https://bikhra.com/books/empire-freedom',
    image: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/rrqhclq1pks7yvy4sps2m3h3/messages/gemini_generated_image_z7ry5oz7ry5oz7ry-v61f4l05t98.jpg'
  },
  empireFreedomReader: {
    title: 'Reading: Empire & Freedom — The Bikhra Collective',
    description: 'Experience a visual journey through India\'s independence movement, from the arrival of the East India Company to the birth of the world\'s largest democracy.',
    url: 'https://bikhra.com/books/empire-freedom?read=true',
    image: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2RBkUqh3LVjYlDQLDGXc6cEkFC7/rrqhclq1pks7yvy4sps2m3h3/messages/gemini_generated_image_z7ry5oz7ry5oz7ry-v61f4l05t98.jpg'
  }
};
